module.exports = __webpack_public_path__ + "static/media/edit.66a43e3e.png";